import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div(
  ({ theme }) => css`
    width: 625px;
    padding: 0 ${theme.spacers!.spacer02};
    border-radius: 16px;
    border: 1px solid ${theme.admanColors!.gray.light.bg0[3]};
    min-height: 50px;
    background-color: ${theme.colors!.colorWhite};
  `
);

export const StyledHeader = styled.div(
  ({ theme }) => css`
    height: 62px;
    border-bottom: 1px solid ${theme.admanColors!.gray.light.bg0[3]};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.spacers!.spacer05};
  `
);

export const StyledTotalWrapper = styled.div(
  ({ theme }) => css`
    color: ${theme.admanColors!.gray.light.fg[1]};
    font-family: Graphik;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
  `
);

export const StyledTotalCount = styled.span(
  ({ theme }) => css`
    font-weight: 400;
  `
);

export const StyledReadAllLink = styled.div(
  ({ theme }) => css`
    color: ${theme.admanColors!.gray.light.fg[2]};
    font-family: Graphik;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;

    :hover {
      cursor: pointer;
    }
  `
);

export const StyledRow = styled.div(
  ({ theme }) => css`
    height: 80px;
    display: flex;
    border-bottom: 1px solid ${theme.admanColors!.gray.light.bg0[3]};
    justify-content: space-between;
    padding: ${theme.spacers!.spacer04};
  `
);

export const StyledFooter = styled.div(
  ({ theme }) => css`
    color: ${theme.admanColors!.blue.light.bg1[5]};
    text-align: center;
    font-family: Graphik;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    height: 61px;
    display: flex;
    align-items: center;
    justify-content: center;

    :hover {
      cursor: pointer;
    }
  `
);

export const StyledIndicatorCell = styled.div`
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledImage = styled.img`
  width: 48px;
  height: 48px;
  border: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.bg0[3]};
  border-radius: 50%;
  margin-right: ${({ theme }): string => theme.spacers!.spacer02};
`;

export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  width: 460px;
`;

export const StyledContentTitle = styled.div`
  color: ${({ theme }): string => theme.admanColors!.gray.light.fg[2]};
  font-family: Graphik;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0;
  text-transform: uppercase;
  justify-content: space-between;
`;

export const StyledContent = styled.div<{ $isUnread?: boolean }>(
  ({ theme, $isUnread }) => css`
    color: ${theme.admanColors!.gray.light.fg[1]};
    font-family: Graphik;
    font-size: 14px;
    font-style: normal;
    font-weight: ${$isUnread ? 500 : 400};
    line-height: 160%;
    max-width: 460px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    a {
      color: ${theme.admanColors!.blue.solid};
      font-weight: 500;
      text-decoration: none;
    }
  `
);

export const StyledIndicator = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ theme }): string => theme.admanColors!.blue.dark.bg2[3]};
`;

export const StyledEmptyRow = styled.div`
  height: 86px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Graphik;
  font-size: 14px;
  font-weight: 400;
`;
